import React from "react";
import styled from "styled-components";
import InkassierLogo from "./icons/InkassierLogo";
const StyledInkassier = styled(InkassierLogo) `
    position: relative;
    display: block;
    width: 236px;
    height: 67px;
    margin: 30px auto 50px auto;
    z-index: 1;

    @media only screen and (min-width: 992px) {
        margin: 20px auto 30px auto;
    }

    @media only screen and (min-width: 1400px) {
        position: absolute;
        top: 70px;
        left: 70px;
        width: 293px;
        height: 84px;
        transform: none;
    }
`;
const Logo = ({ appTheme }) => {
    const getLogo = (appTheme) => {
        if (appTheme === "inkassier") {
            return React.createElement(StyledInkassier, null);
        }
    };
    return React.createElement(React.Fragment, null, getLogo(appTheme));
};
export default Logo;
